export var SupportedMessageFormats;
(function (SupportedMessageFormats) {
    SupportedMessageFormats["jsonrpc2.0"] = "jsonrpc2.0";
})(SupportedMessageFormats || (SupportedMessageFormats = {}));
//# sourceMappingURL=index.js.map